import React from "react";

export function HrSummaryPanel({
  variant = "sidebar",
  title,
  "aria-label": ariaLabel = "סיכום הזמנה",
  className = "",
  children,
}) {
  return (
    <aside
      className={
        "hr-order-summary-panel" +
        (variant === "compact" ? " hr-order-summary-panel--compact" : "") +
        (className ? ` ${className}` : "")
      }
      aria-label={ariaLabel}
    >
      {title ? <h2 className="hr-order-summary-panel__label">{title}</h2> : null}
      {children}
    </aside>
  );
}
